import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface ISettingsStore {
  isSidebarOpen: boolean;
  serviceError: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  setServiceError: (serviceError: boolean) => void;
}

export const useSettingsStore = createWithEqualityFn<ISettingsStore>()(
  devtools(
    (set) => ({
      isSidebarOpen: false,
      serviceError: false,
      openSidebar: () => set({ isSidebarOpen: true }),
      closeSidebar: () => set({ isSidebarOpen: false }),
      setServiceError: (serviceError) => set({ serviceError }),
    }),
    { name: "Settings Store" },
  ),
  shallow,
);

export const setServiceError = (error: boolean) => {
  const setError = useSettingsStore.getState().setServiceError;
  setError(error);
};
